import Icon from "@hudson/ui/components/Icon";

function locationName(loc: be.Location): string {
  if (
    loc.type == "A" &&
    loc.code &&
    loc.code[0].toLowerCase() != "x" &&
    loc.code[1].toLowerCase() != "x"
  )
    return loc.code;
  else return loc.displayName || "";
}

function ResPickpuDropoffLabel({
  pickup,
  dropoff,
}: {
  pickup: be.Location;
  dropoff: be.Location;
}): JSX.Element {
  return (
    <>
      {locationName(pickup)}
      <Icon type="arrowRight" color="black" className="mx-1 w-6 h-6" /> {locationName(dropoff)}
    </>
  );
}

export default ResPickpuDropoffLabel;
